<template>
    <div>

        <v-menu

            open-on-hover
            :close-on-content-click="false"
            offset-x
            left
            >
            <template v-slot:activator="{ on, attrs }">
                <v-btn  style="position:absolute; top: 148px; right: 13px; z-index:1001;"
                        color="primary"
                        dark

                        fab
                        v-bind="attrs"
                        v-on="on"
                        >
                    <v-icon>mdi-filter-menu</v-icon>
                </v-btn>
            </template>

            <v-list>

                <v-list-item>

                    <v-checkbox
                        v-model="filter"
                        label="Пожарные части"
                        value="stations"
                        ></v-checkbox>

                </v-list-item>
                <v-list-item>

                    <v-checkbox
                        v-model="filter"
                        label="Районы выезда"
                        value="areas"
                        ></v-checkbox>
                </v-list-item>
                <v-list-item>

                    <v-checkbox
                        v-model="filter"
                        label="Водоисточники"
                        value="waterSource"
                        ></v-checkbox>

                </v-list-item>
                <v-list-item>

                    <v-checkbox
                        v-model="filter"
                        label="Объекты"
                        value="objects"
                        ></v-checkbox>


                </v-list-item>
            </v-list>
        </v-menu>
        <v-btn fab dark  v-if="stations.find(el=>el.isAdmin==true)" :color="allowEdit==false?'gray':'blue'" style="position:absolute; top: 208px; right: 13px; z-index:1001;" @click="allowEdit=!allowEdit"><v-icon v-if='allowEdit==false'>mdi-toggle-switch-off-outline</v-icon><v-icon v-else>mdi-toggle-switch-outline</v-icon></v-btn>
        <v-btn fab  v-if="stations.find(el=>el.isAdmin==true) " style="position:absolute; top: 268px; right: 13px; z-index:1001;" draggable="true" @click="isMobile==true?mapAction='objectAdd':null" @dragstart.stop = "mapAction='objectAdd'" ><v-icon>mdi-office-building-marker-outline</v-icon></v-btn>
        <v-btn fab  v-if="stations.find(el=>el.isAdmin==true) " style="position:absolute; top: 328px; right: 13px; z-index:1001;" draggable="true" @click="isMobile==true?mapAction='waterAdd':null" @dragstart.stop = "mapAction='waterAdd'"><v-icon>mdi-water</v-icon></v-btn>
        <v-btn fab  v-if="stations.find(el=>el.isAdmin==true) " style="position:absolute; top: 388px; right: 13px; z-index:1001;" draggable="true" @click="isMobile==true?mapAction='eventAdd':null" @dragstart.stop = "mapAction='eventAdd'"><v-icon  color="red">mdi-alert</v-icon></v-btn>
        <v-btn fab style="position:absolute; top: 448px; right: 13px; z-index:1001;" @click="testDialog=true" v-if="$auth.user().profile.user_id==1"><v-icon  color="blue">mdi-file-chart-outline</v-icon></v-btn>
        <div style="height: calc(100vh - 64px); width: 100%;" name="map"  @dragover="allowDrop($event)"  @drop="drop($event)" @click.stop="isMobile==true?drop($event):null"
             >

            <v-navigation-drawer style="z-index:1002; "
                                 v-model="drawer"

                                 width='465'
                                 absolute
                                 temporary
                                 stateless

                                 hide-overlay
                                 tag="map"
                                 >
                <v-btn height="100%" @click="drawer=null;closePath()" v-if="!isMobile" style="position:absolute; right: 0px;" ><v-icon>mdi-arrow-left</v-icon></v-btn>
                <objectView :isMobile="isMobile" @showPath="showPath" :style="isMobile?'max-width:100%;':'max-width:400px;'" :docView.sync="drawer2" :object.sync="viewTarget" :editMod.sync="objectEdit" :stations.sync="stations" v-if="viewMod=='object'" @close="drawer=false"/>
                <waterView :isMobile="isMobile" @showPath="showPath" :style="isMobile?'max-width:100%;':'max-width:400px;'"  :docView.sync="drawer2" :waterSources.sync="waterSources"  :object.sync="viewTarget" :editMod.sync="objectEdit" :stations.sync="stations" v-if="viewMod=='water'" @close="drawer=false"/>
                <stationView :isMobile="isMobile" :style="isMobile?'max-width:100%;':'max-width:400px;'" @borderAdd="$set(viewTarget,'serviceArea',{dots:[]});mapAction='borderAdd';viewTarget.areaEdited=true" :docView.sync="drawer2" :object.sync="viewTarget" v-if="viewMod=='station'" @close="drawer=false"/>
            </v-navigation-drawer>
            <v-navigation-drawer style="z-index:1002; "
                                 v-model="drawer2"
                                 right
                                 :width='isMobile?"100%":drawer2Width()'
                                 absolute
                                 temporary
                                 stateless

                                 hide-overlay
                                 tag="map"
                                 >
                <v-btn height="100%" @click="drawer2=null" v-if="!isMobile" style="position:absolute;"><v-icon>mdi-arrow-right</v-icon></v-btn>
                <div v-if="drawer2 && drawer2.src" :style="isMobile?'':'margin-left: 65px;'">
                    <center><h3 class='ma-0 pa-3' ref="fileName">{{drawer2.name}}</h3></center><v-btn fab v-if="isMobile" dark small color="red" @click="drawer2=null" style="position:absolute; top:10px; right:10px;"><v-icon>mdi-close</v-icon></v-btn>
                    <iframe v-if='drawer2.ext=="docx"' :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + drawer2.src" width="100%" :height="getFileHeight()" frameborder='0'>This is an embedded <a target='_blank' href='https://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='https://office.com/webapps'>Office Online</a>.</iframe>
                    <object  v-if='drawer2.ext=="pdf"'><embed :src="drawer2.src" width="100%"  :height="getFileHeight()" /></object>
                    <v-img v-if='drawer2.ext!="docx" && drawer2.ext!="pdf"' :src="drawer2.src" contain :max-height="getFileHeight()"/>
                </div>
            </v-navigation-drawer>
            <v-alert
                icon="mdi-marker"
                text
                style='margin-bottom: 0px;'
                type="info"
                v-show="isMobile && (mapAction=='objectAdd' || mapAction=='waterAdd' || mapAction=='eventAdd')"
                >
                Теперь нажмите на область куда нужно добавить обьект <v-btn color="red" small @click='mapAction=""'>Отменить</v-btn>
            </v-alert>
            <l-map 


                ref="mapBase"
                @mouseover="updateCords"
                @click='mapClickAction'    
                :zoom="zoom"
                :center="center"
                :options="mapOptions"
                style="height: 100%"
                @update:center="centerUpdate"
                @update:zoom="zoomUpdate"
                >
                <l-control-zoom position="topright"  ></l-control-zoom>
                <v-geosearch :options="geosearchOptions" @search="search"></v-geosearch>
                <l-tile-layer
                    ref='leafMap'
                    :url="url"
                    :attribution="attribution"
                    />
                <l-marker  :duration="5000" :lat-lng="getCords([track.lat, track.lng])" :key="'t'+track.id" v-for="track in tracks">
                    <l-icon
                        >
                        <img src="truck.png" height="32" width="32">
                    </l-icon>

                    <l-tooltip :options="{ permanent: false}">
                        <span v-if="track.state=='home'">В части</span>
                        <span v-if="track.state=='onWay'">В пути</span>
                        <span v-if="track.state=='fault'">Неисправность</span>
                        <span v-if="track.state=='onFire'">На месте происшествия</span>
                    </l-tooltip>

                    <l-popup >
                        <h3>{{track.name}}</h3>

                    </l-popup>
                </l-marker>
                <l-marker  v-if="searchMarker.latLng" :lat-lng="getCords([searchMarker.latLng[0], searchMarker.latLng[1]])">
                    <l-tooltip :options="{ permanent: true, interactive: true }">
                        <v-btn @click="showPath(searchMarker)">Проложить маршрут</v-btn>

                    </l-tooltip>
                </l-marker>    
                <l-marker  v-for="event in events" :lat-lng="getCords([event.latLng[0], event.latLng[1]])" :key="event.id" >
                    <l-icon>
                        <v-icon color='red' size='28'>mdi-alert</v-icon>
                    </l-icon>
                    <l-tooltip>
                        {{event.desc}}


                    </l-tooltip>
                    <l-popup>
                        <v-btn @click='eventDelete(event)'>Удалить</v-btn>
                    </l-popup>
                </l-marker> 
                <div v-if="filter.find(el=>el=='waterSource') && waterSources">
                    <div  :key="'w'+waterSource.id+'c'+waterSource.count"  v-for="(waterSource,index) in waterSources">
                        <l-marker v-if="!waterSource.count || waterSource.count==1" :draggable="stations.findIndex(el=>el.id==waterSource.stationId && el.isAdmin && el.isAdmin==true)!=-1 && allowEdit==true" @dragend="waterNewPos($event,index)" @click="viewWater(waterSource)"  :lat-lng="[waterSource.latitude,waterSource.longitude]" >
                            <l-icon
                                :icon-anchor="[24,-56]"
                                class-name="someExtraClass"
                                >
                                <img :src="waterSource.state==1? '/PG.png':'/PG_broken.png'">
                            </l-icon>
                        </l-marker>
                        <l-marker v-else :lat-lng="[waterSource.latitude,waterSource.longitude]" >
                            <l-icon
                                :icon-anchor="[24,-56]"
                                class-name="someExtraClass"
                                >
                                <img :src="waterSource.state==1? '/PG.png':'/PG_broken.png'"><b style="position: absolute; top: 8px; left: 8px; color:#000;">{{waterSource.count}}</b>
                            </l-icon>

                        </l-marker>
                    </div>
                </div>
                <div v-for="(marker,index) in stations" :key="marker.id">
                    <div v-if="filter.find(el=>el=='stations')">
                        <l-marker  :lat-lng="getCords(marker.cords)" :icon="getIcon('/pch.png')" @click="viewStation(marker)">
                        </l-marker>

                        <l-marker v-show="filter.sections==1"  :key="'m'+index" :lat-lng="marker.cords">
                            <l-icon
                                :icon-anchor="[0,0]"
                                class-name="someExtraClass">
                                {{ marker.name }}
                            </l-icon>
                        </l-marker>
                    </div>

                    <div v-if="filter.find(el=>el=='objects') && marker.areaObjects">
                        <v-marker-cluster :options="{animateAddingMarkers:true,maxClusterRadius:48}" >
                            <l-marker :draggable="marker.isAdmin==true && allowEdit==true" @dragend="objectNewPos($event,marker,index)" v-for="(object,index) in marker.areaObjects" :key="index" :lat-lng="object.latLng" @click="viewObject(marker,object)">
                                <l-icon
                                    :icon-anchor="[24,-56]"
                                    class-name="someExtraClass"
                                    >
                                    <img :src="getObjectIcon(object.type)" width="48"  height="48">
                                </l-icon>

                            </l-marker>
                        </v-marker-cluster>
                    </div>
                    <div  v-if="filter.find(el=>el=='areas') && marker.serviceArea">
                        <l-polygon
                            :lat-lngs="marker.serviceArea.dots"
                            :color="getColor(index)"
                            :fillColor="getColor(index)"
                            @click="areaShowMarkers(index)"
                            >
                        </l-polygon>
                        <span v-if="marker.areaEdited && allowEdit==true">
                            <v-marker-cluster :options="{animateAddingMarkers:true,maxClusterRadius:30,}">
                                <l-marker :draggable="marker.isAdmin==true && allowEdit==true" @drag="areaUpdate($event,marker.id,dindex)" @dragend="areaSaveCords(marker.serviceArea,marker.id)" v-for="(dot,dindex) in marker.serviceArea.dots" :lat-lng="dot" :key="'d'+dindex">
                                    <l-popup>
                                        <v-btn-toggle >
                                            <v-btn small @click="addPoint(marker.serviceArea,dindex,marker.id)">Добавить точку</v-btn>
                                            <v-btn small @click="removePoint(marker.serviceArea,dindex,marker.id)">Удалить точку</v-btn>
                                        </v-btn-toggle>
                                    </l-popup>
                                </l-marker>
                            </v-marker-cluster></span>
                        <l-marker v-if="viewTarget.id==marker.id && mapAction=='borderAdd' && marker.serviceArea && marker.serviceArea.dots && marker.serviceArea.dots.length>2" :lat-lng="marker.serviceArea.dots[marker.serviceArea.dots.length - 1]">
                            <l-tooltip :options="{ permanent: true, interactive: true}">

                                <v-btn small @click="mapAction=null">Завершить</v-btn>

                            </l-tooltip>
                        </l-marker>
                    </div>
                </div>
                <v-btn v-if="waypoints.length>1" fab small style="position: absolute; top: 90px; right:100px;z-index:1001" @click="waypoints=[]"><v-icon>mdi-close</v-icon></v-btn>
                <l-routing-machine v-if="waypoints.length>1" :waypoints="waypoints"/>
            </l-map>

        </div>

        <v-dialog v-model="testDialog" scrollable max-width="1400px" >
            <v-img src="test.png"/>
        </v-dialog>
        <v-dialog v-model="newObjectDialog" scrollable max-width="600px" >
            <v-card>
                <objectView  v-if="viewMod=='object'" :editMod.sync="objectEdit"  :stations.sync="stations" @close="newObjectDialog=false" :object="viewTarget"/>
                <waterView v-if="viewMod=='water'" 
                           :editMod.sync="objectEdit" 
                           :stations.sync="stations" 
                           :waterSources.sync="waterSources" 
                           @close="newObjectDialog=false" :object.sync="viewTarget"/>

                <v-card-text  v-if="viewMod=='event'">
                    <v-list class="ma-0">


                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="red">mdi-alert</v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <h3>Добавить событие</h3>

                            </v-list-item-content>
                            <v-list-item-action>
                                <v-btn icon @click='newObjectDialog=false' class="ma-1"><v-icon color='error'>mdi-close</v-icon></v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list><v-divider/>
                    <v-textarea dense hide-details="auto" class="pa-0 ma-3" label="Описание" v-model='viewTarget.desc' auto-grow :rows="1" row-height="20"></v-textarea>
                    <center><v-btn  @click='eventSave()'  class="ma-0" color="success">Сохранить<v-icon>mdi-content-save</v-icon></v-btn></center>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<style>
    .leaflet-routing-container{
        margin-right:90px !important;
    }
    .glass {
        height: 30px !important;
    }
    .popupWater{
        margin-top: 46px;
    }
    .someExtraClass {
        position: absolute;
        top:-75px;
        left:7px;
        color:#FFF;
        width: auto !important;
        height: auto !important;
    }
</style>

<script>
    import "leaflet-geosearch/assets/css/leaflet.css";
    import LRoutingMachine from './LRoutingMachine'
    const color = [ { "colorId": 0, "hexString": "#000000", "rgb": { "r": 0, "g": 0, "b": 0 }, "hsl": { "h": 0, "s": 0, "l": 0 }, "name": "Black" }, { "colorId": 1, "hexString": "#800000", "rgb": { "r": 128, "g": 0, "b": 0 }, "hsl": { "h": 0, "s": 100, "l": 25 }, "name": "Maroon" }, { "colorId": 2, "hexString": "#008000", "rgb": { "r": 0, "g": 128, "b": 0 }, "hsl": { "h": 120, "s": 100, "l": 25 }, "name": "Green" }, { "colorId": 3, "hexString": "#808000", "rgb": { "r": 128, "g": 128, "b": 0 }, "hsl": { "h": 60, "s": 100, "l": 25 }, "name": "Olive" }, { "colorId": 4, "hexString": "#000080", "rgb": { "r": 0, "g": 0, "b": 128 }, "hsl": { "h": 240, "s": 100, "l": 25 }, "name": "Navy" }, { "colorId": 5, "hexString": "#800080", "rgb": { "r": 128, "g": 0, "b": 128 }, "hsl": { "h": 300, "s": 100, "l": 25 }, "name": "Purple" }, { "colorId": 6, "hexString": "#008080", "rgb": { "r": 0, "g": 128, "b": 128 }, "hsl": { "h": 180, "s": 100, "l": 25 }, "name": "Teal" }, { "colorId": 9, "hexString": "#ff0000", "rgb": { "r": 255, "g": 0, "b": 0 }, "hsl": { "h": 0, "s": 100, "l": 50 }, "name": "Red" }, { "colorId": 10, "hexString": "#00ff00", "rgb": { "r": 0, "g": 255, "b": 0 }, "hsl": { "h": 120, "s": 100, "l": 50 }, "name": "Lime" }, { "colorId": 11, "hexString": "#ffff00", "rgb": { "r": 255, "g": 255, "b": 0 }, "hsl": { "h": 60, "s": 100, "l": 50 }, "name": "Yellow" }, { "colorId": 12, "hexString": "#0000ff", "rgb": { "r": 0, "g": 0, "b": 255 }, "hsl": { "h": 240, "s": 100, "l": 50 }, "name": "Blue" }, { "colorId": 13, "hexString": "#ff00ff", "rgb": { "r": 255, "g": 0, "b": 255 }, "hsl": { "h": 300, "s": 100, "l": 50 }, "name": "Fuchsia" }, { "colorId": 14, "hexString": "#00ffff", "rgb": { "r": 0, "g": 255, "b": 255 }, "hsl": { "h": 180, "s": 100, "l": 50 }, "name": "Aqua" }, { "colorId": 22, "hexString": "#005f00", "rgb": { "r": 0, "g": 95, "b": 0 }, "hsl": { "h": 120, "s": 100, "l": 18 }, "name": "DarkGreen" }, { "colorId": 23, "hexString": "#005f5f", "rgb": { "r": 0, "g": 95, "b": 95 }, "hsl": { "h": 180, "s": 100, "l": 18 }, "name": "DeepSkyBlue4" }, { "colorId": 25, "hexString": "#005faf", "rgb": { "r": 0, "g": 95, "b": 175 }, "hsl": { "h": 207.428571428571, "s": 100, "l": 34 }, "name": "DeepSkyBlue4" }, { "colorId": 28, "hexString": "#008700", "rgb": { "r": 0, "g": 135, "b": 0 }, "hsl": { "h": 120, "s": 100, "l": 26 }, "name": "Green4" }, { "colorId": 30, "hexString": "#008787", "rgb": { "r": 0, "g": 135, "b": 135 }, "hsl": { "h": 180, "s": 100, "l": 26 }, "name": "Turquoise4" }, { "colorId": 32, "hexString": "#0087d7", "rgb": { "r": 0, "g": 135, "b": 215 }, "hsl": { "h": 202.325581395349, "s": 100, "l": 42 }, "name": "DeepSkyBlue3" }, { "colorId": 36, "hexString": "#00af87", "rgb": { "r": 0, "g": 175, "b": 135 }, "hsl": { "h": 166.285714285714, "s": 100, "l": 34 }, "name": "DarkCyan" }, { "colorId": 39, "hexString": "#00afff", "rgb": { "r": 0, "g": 175, "b": 255 }, "hsl": { "h": 198.823529411765, "s": 100, "l": 50 }, "name": "DeepSkyBlue1" }, { "colorId": 40, "hexString": "#00d700", "rgb": { "r": 0, "g": 215, "b": 0 }, "hsl": { "h": 120, "s": 100, "l": 42 }, "name": "Green3" }, { "colorId": 44, "hexString": "#00d7d7", "rgb": { "r": 0, "g": 215, "b": 215 }, "hsl": { "h": 180, "s": 100, "l": 42 }, "name": "DarkTurquoise" }, { "colorId": 52, "hexString": "#5f0000", "rgb": { "r": 95, "g": 0, "b": 0 }, "hsl": { "h": 0, "s": 100, "l": 18 }, "name": "DarkRed" }, { "colorId": 53, "hexString": "#5f005f", "rgb": { "r": 95, "g": 0, "b": 95 }, "hsl": { "h": 300, "s": 100, "l": 18 }, "name": "DeepPink4" }, { "colorId": 57, "hexString": "#5f00ff", "rgb": { "r": 95, "g": 0, "b": 255 }, "hsl": { "h": 262.352941176471, "s": 100, "l": 50 }, "name": "BlueViolet" }, { "colorId": 58, "hexString": "#5f5f00", "rgb": { "r": 95, "g": 95, "b": 0 }, "hsl": { "h": 60, "s": 100, "l": 18 }, "name": "Orange4" }, { "colorId": 63, "hexString": "#5f5fff", "rgb": { "r": 95, "g": 95, "b": 255 }, "hsl": { "h": 240, "s": 100, "l": 68 }, "name": "RoyalBlue1" }, { "colorId": 64, "hexString": "#5f8700", "rgb": { "r": 95, "g": 135, "b": 0 }, "hsl": { "h": 77.7777777777778, "s": 100, "l": 26 }, "name": "Chartreuse4" }, { "colorId": 67, "hexString": "#5f87af", "rgb": { "r": 95, "g": 135, "b": 175 }, "hsl": { "h": 210, "s": 33, "l": 52 }, "name": "SteelBlue" }, { "colorId": 73, "hexString": "#5fafaf", "rgb": { "r": 95, "g": 175, "b": 175 }, "hsl": { "h": 180, "s": 33, "l": 52 }, "name": "CadetBlue" }, { "colorId": 79, "hexString": "#5fd7af", "rgb": { "r": 95, "g": 215, "b": 175 }, "hsl": { "h": 160, "s": 60, "l": 60 }, "name": "Aquamarine3" }, { "colorId": 83, "hexString": "#5fff5f", "rgb": { "r": 95, "g": 255, "b": 95 }, "hsl": { "h": 120, "s": 100, "l": 68 }, "name": "SeaGreen2" }, { "colorId": 87, "hexString": "#5fffff", "rgb": { "r": 95, "g": 255, "b": 255 }, "hsl": { "h": 180, "s": 100, "l": 68 }, "name": "DarkSlateGray2" }, { "colorId": 88, "hexString": "#870000", "rgb": { "r": 135, "g": 0, "b": 0 }, "hsl": { "h": 0, "s": 100, "l": 26 }, "name": "DarkRed" }, { "colorId": 91, "hexString": "#8700af", "rgb": { "r": 135, "g": 0, "b": 175 }, "hsl": { "h": 286.285714285714, "s": 100, "l": 34 }, "name": "DarkMagenta" }, { "colorId": 94, "hexString": "#875f00", "rgb": { "r": 135, "g": 95, "b": 0 }, "hsl": { "h": 42.2222222222222, "s": 100, "l": 26 }, "name": "Orange4" }, { "colorId": 97, "hexString": "#875faf", "rgb": { "r": 135, "g": 95, "b": 175 }, "hsl": { "h": 270, "s": 33, "l": 52 }, "name": "MediumPurple3" }, { "colorId": 101, "hexString": "#87875f", "rgb": { "r": 135, "g": 135, "b": 95 }, "hsl": { "h": 60, "s": 17, "l": 45 }, "name": "Wheat4" }, { "colorId": 105, "hexString": "#8787ff", "rgb": { "r": 135, "g": 135, "b": 255 }, "hsl": { "h": 240, "s": 100, "l": 76 }, "name": "LightSlateBlue" }, { "colorId": 106, "hexString": "#87af00", "rgb": { "r": 135, "g": 175, "b": 0 }, "hsl": { "h": 73.7142857142857, "s": 100, "l": 34 }, "name": "Yellow4" }, { "colorId": 112, "hexString": "#87d700", "rgb": { "r": 135, "g": 215, "b": 0 }, "hsl": { "h": 82.3255813953488, "s": 100, "l": 42 }, "name": "Chartreuse2" }, { "colorId": 127, "hexString": "#af00af", "rgb": { "r": 175, "g": 0, "b": 175 }, "hsl": { "h": 300, "s": 100, "l": 34 }, "name": "Magenta3" }, { "colorId": 130, "hexString": "#af5f00", "rgb": { "r": 175, "g": 95, "b": 0 }, "hsl": { "h": 32.5714285714286, "s": 100, "l": 34 }, "name": "DarkOrange3" }, { "colorId": 135, "hexString": "#af5fff", "rgb": { "r": 175, "g": 95, "b": 255 }, "hsl": { "h": 270, "s": 100, "l": 68 }, "name": "MediumPurple2" }, { "colorId": 137, "hexString": "#af875f", "rgb": { "r": 175, "g": 135, "b": 95 }, "hsl": { "h": 30, "s": 33, "l": 52 }, "name": "LightSalmon3" }, { "colorId": 142, "hexString": "#afaf00", "rgb": { "r": 175, "g": 175, "b": 0 }, "hsl": { "h": 60, "s": 100, "l": 34 }, "name": "Gold3" }, { "colorId": 148, "hexString": "#afd700", "rgb": { "r": 175, "g": 215, "b": 0 }, "hsl": { "h": 71.1627906976744, "s": 100, "l": 42 }, "name": "Yellow3" }, { "colorId": 159, "hexString": "#afffff", "rgb": { "r": 175, "g": 255, "b": 255 }, "hsl": { "h": 180, "s": 100, "l": 84 }, "name": "PaleTurquoise1" }, { "colorId": 172, "hexString": "#d78700", "rgb": { "r": 215, "g": 135, "b": 0 }, "hsl": { "h": 37.6744186046512, "s": 100, "l": 42 }, "name": "Orange3" }, { "colorId": 178, "hexString": "#d7af00", "rgb": { "r": 215, "g": 175, "b": 0 }, "hsl": { "h": 48.8372093023256, "s": 100, "l": 42 }, "name": "Gold3" }, { "colorId": 184, "hexString": "#d7d700", "rgb": { "r": 215, "g": 215, "b": 0 }, "hsl": { "h": 60, "s": 100, "l": 42 }, "name": "Yellow3" }, { "colorId": 192, "hexString": "#d7ff87", "rgb": { "r": 215, "g": 255, "b": 135 }, "hsl": { "h": 80, "s": 100, "l": 76 }, "name": "DarkOliveGreen1" }, { "colorId": 199, "hexString": "#ff00af", "rgb": { "r": 255, "g": 0, "b": 175 }, "hsl": { "h": 318.823529411765, "s": 100, "l": 50 }, "name": "DeepPink1" }, { "colorId": 202, "hexString": "#ff5f00", "rgb": { "r": 255, "g": 95, "b": 0 }, "hsl": { "h": 22.3529411764706, "s": 100, "l": 50 }, "name": "OrangeRed1" }, { "colorId": 208, "hexString": "#ff8700", "rgb": { "r": 255, "g": 135, "b": 0 }, "hsl": { "h": 31.7647058823529, "s": 100, "l": 50 }, "name": "DarkOrange" }, { "colorId": 215, "hexString": "#ffaf5f", "rgb": { "r": 255, "g": 175, "b": 95 }, "hsl": { "h": 30, "s": 100, "l": 68 }, "name": "SandyBrown" }, { "colorId": 219, "hexString": "#ffafff", "rgb": { "r": 255, "g": 175, "b": 255 }, "hsl": { "h": 300, "s": 100, "l": 84 }, "name": "Plum1" }, { "colorId": 221, "hexString": "#ffd75f", "rgb": { "r": 255, "g": 215, "b": 95 }, "hsl": { "h": 45, "s": 100, "l": 68 }, "name": "LightGoldenrod2" }, { "colorId": 225, "hexString": "#ffd7ff", "rgb": { "r": 255, "g": 215, "b": 255 }, "hsl": { "h": 300, "s": 100, "l": 92 }, "name": "Thistle1" }, { "colorId": 226, "hexString": "#ffff00", "rgb": { "r": 255, "g": 255, "b": 0 }, "hsl": { "h": 60, "s": 100, "l": 50 }, "name": "Yellow1" }, { "colorId": 232, "hexString": "#080808", "rgb": { "r": 8, "g": 8, "b": 8 }, "hsl": { "h": 0, "s": 0, "l": 3 }, "name": "Grey3" }, { "colorId": 236, "hexString": "#303030", "rgb": { "r": 48, "g": 48, "b": 48 }, "hsl": { "h": 0, "s": 0, "l": 18 }, "name": "Grey19" } ]
    import objectView from './objectView'
    import waterView from './waterView'
    import stationView from './stationView'
    import "leaflet.markercluster/dist/MarkerCluster.css";
    import "leaflet.markercluster/dist/MarkerCluster.Default.css";
    import { Icon } from 'leaflet';
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
            iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
            iconUrl: require('leaflet/dist/images/marker-icon.png'),
            shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
    import { latLng, point, icon  } from "leaflet";
    import { LMap, LTileLayer, LMarker, LPopup, LPolygon, LIcon, LControlZoom, LTooltip } from "vue2-leaflet";
    import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
    import { OpenStreetMapProvider } from 'leaflet-geosearch';
    import VGeosearch from './Vue2LeafletGeosearch';
    export default {
        name: "Example",
        components: {
            LRoutingMachine,
            LMap,
            LControlZoom,
            LTileLayer,
            LMarker,
            LPolygon,
            LPopup,
            LIcon,
            LTooltip,
            objectView,
            waterView,
            stationView,
            'v-marker-cluster': Vue2LeafletMarkerCluster,
            VGeosearch
        },
        data() {
            return {
                testDialog: false,
                isMobile: false,
                allowEdit: false,
                geosearchOptions: {// Important part Here
                    provider: new OpenStreetMapProvider(),
                    searchLabel: 'Введите адрес',
                    showMarker: false
                },
                waypoints: [
                ],
                searchMarker: {},
                timer: null,
                events: [],
                tracks: [],
                drawer2: null,
                objectEdit: false,
                newObjectDialog: false,
                mousePos: {lat: 0, lng: 0},
                mapAction: null,
                viewTarget: {},
                viewMod: null,
                drawer: null,
                zoom: 13,
                center: latLng(54.193371, 37.610086),
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution:
                        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                stations: [],
                currentZoom: 11.5,
                currentCenter: latLng(54.193371, 37.610086),
                mapOptions: {
                    cursor: true,
                    zoomControl: false,
                },
                filter: ['stations', 'garrison', 'areas', 'waterSource', 'objects'],
                areas: [],
                waterSources: [],
                areaObjects: []
            }
        },
        watch: {
            viewTarget() {
                this.mapAction = null
            }
        },
        methods: {
            onResize() {
                this.isMobile = window.innerWidth < 600
            },
            eventDelete(event) {
                this.$http.post('stations/event-delete?id=' + event.id,
                        this.viewTarget).then(() => {
                    let key = this.events.findIndex(el => el.id == event.id)
                    this.events.splice(key, 1)
                })

            },
            eventSave() {
                this.$http.post('stations/event-add',
                        this.viewTarget).then((response) => {
                    this.events.push(response.data)
                    this.newObjectDialog = false
                })
            },
            search(result) {
                this.$set(this.searchMarker, 'latLng', [result.location.y, result.location.x])
                console.log(result)
            },
            closePath() {
                this.$set(this, 'waypoints', [])
            },
            showPath(object) {
                this.searchMarker = {}
                if (this.waypoints[1] && (this.waypoints[1].lat == object.latLng[0] && this.waypoints[1].lng == object.latLng[1])) {
                    this.closePath()
                } else {
                    this.$set(this, 'waypoints', [])
                    this.$nextTick(() => {
                        this.$set(this, 'waypoints', [{lat: '54.224732', lng: '37.679808'}, {lat: object.latLng[0], lng: object.latLng[1]}])
                    })
                }
            },
            removePoint(area, index, stationId) {
                area.dots.splice(index, 1)
                this.areaSaveCords(area, stationId)
            },
            addPoint(area, index, stationId) {
                area.dots.splice(index, 0, [area.dots[index][0] + 0.002, area.dots[index][1] + 0.002])
                this.areaSaveCords(area, stationId)
            },
            getFileHeight() {

                const height = window.innerHeight || document.documentElement.clientHeight ||
                        document.body.clientHeight;
                return height - 52

            },
            drawer2Width() {
                const width = window.innerWidth || document.documentElement.clientWidth ||
                        document.body.clientWidth;
                return width - 400
            },
            viewObject(station, object) {

                this.viewTarget = object
                this.viewMod = 'object'
                this.drawer = true
                this.objectEdit = false
                console.log(station)
                if (station.isAdmin) {
                    this.$set(this.viewTarget, 'isAdmin', true)
                }
            },
            viewWater(object) {
                var station = this.stations.find(el => el.id == object.stationId)
                this.viewTarget = object
                this.viewMod = 'water'
                this.drawer = true
                this.objectEdit = false
                console.log(station)
                if (station.isAdmin) {
                    this.$set(this.viewTarget, 'isAdmin', true)
                }
            },
            viewStation(station) {
                this.viewTarget = station
                this.viewMod = 'station'
                this.drawer = true
                this.objectEdit = false
                console.log(station)
                if (station.isAdmin) {
                    this.$set(this.viewTarget, 'isAdmin', true)
                }
            },
            updateCords(ev) {
                console.log(ev)
                this.mousePos = ev.latlng
            },
            mapClickAction(ev) {

                var cords = ev.latlng
                this.tempLine.push([cords.lat, cords.lng])

                if (this.mapAction == 'borderAdd') {
                    var station = this.stations.find(el => el.id == this.viewTarget.id)
                    console.log(station)
                    if (!station.serviceArea) {
                        station.serviceArea = {dots: []}


                    }
                    station.serviceArea.dots.push([cords.lat, cords.lng])
                    if (station.serviceArea.dots.length > 2) {
                        this.areaSaveCords(station.serviceArea, station.id)
                    }
                }
            },
            drop(ev) {
                let cords = this.$refs.mapBase.mapObject.containerPointToLatLng(point(ev.layerX, ev.layerY))
                ev.preventDefault();
                if (this.mapAction == 'objectAdd') {
                    this.viewTarget = {};
                    this.$set(this.viewTarget, 'latLng', [cords.lat, cords.lng])
                    this.drawer = false
                    this.newObjectDialog = true
                    this.viewMod = 'object'
                    this.objectEdit = true
                    this.mapAction = null
                    console.log(this.mousePos)

                }
                if (this.mapAction == 'waterAdd') {
                    this.viewTarget = {};
                    this.$set(this.viewTarget, 'latLng', [cords.lat, cords.lng])
                    this.drawer = false
                    this.newObjectDialog = true
                    this.viewMod = 'water'
                    this.objectEdit = true
                    this.mapAction = null
                    console.log(this.mousePos)

                }
                if (this.mapAction == 'eventAdd') {
                    this.viewTarget = {};
                    this.$set(this.viewTarget, 'latLng', [cords.lat, cords.lng])
                    this.drawer = false
                    this.newObjectDialog = true
                    this.viewMod = 'event'
                    this.objectEdit = true
                    this.mapAction = null

                }

            },
            allowDrop(ev) {
                ev.preventDefault();
            },
            areaSaveCords(area, stationId) {
                this.$http.post('area/border-update?id=' + stationId,
                        {
                            cords: area.dots
                        }).then(() => {

                }).catch(err => {
                    alert('Ошибка')
                    console.log(err)
                })
            },
            getObjectType(type) {
                switch (type) {
                    case 'POO':
                        return 'Потенциально-опасный объект'
                    case 'KVO':
                        return 'Критически важный объект'
                    case 'SIO':
                        return 'Социально-значимый объект'
                    case 'CIO':
                        return 'Объект культурного наследия'
                    case 'NSO':
                        return 'Объект с ночным пребыванием '
                    case 'MPL':
                        return 'Объект с массовым пребыванием людей'
                }
            },
            getObjectIcon(type) {
                switch (type) {
                    case 'POO':
                        return '/map/poo.png'
                    case 'KVO':
                        return '/map/kvo.png'
                    case 'SIO':
                        return '/map/social.png'
                    case 'CIO':
                        return '/map/culture.png'
                    case 'NSO':
                        return '/map/night.png'
                    case 'MPL':
                        return '/map/mass.png'
                }
            },
            getObjectKind(kind) {
                switch (kind) {
                    case 'House':
                        return 'Жилое здание'
                    case 'Child':
                        return 'Детское учреждение'
                    case 'School':
                        return 'Школьное учреждение'
                    case 'Medical':
                        return 'Медицинское учреждение'
                    case 'Prom':
                        return 'Промышленный объект'
                    case 'Admin':
                        return 'Административное учреждение'
                    case 'Religion':
                        return 'Религиозный объект'
                    case 'Sport':
                        return 'Спортивный объект'
                    case 'Tourist':
                        return 'Объект туризма'
                    case 'Trade':
                        return 'Торговый объект'
                }
            },
            areaShowMarkers(index) {
                if (this.stations[index].isAdmin) {
                    this.$set(this.stations[index], 'areaEdited', !this.stations[index].areaEdited)
                }
            },
            areaUpdate(event, stationId, markerIndex) {

                var aIndex = this.stations.findIndex(el => el.id == stationId)
                this.$set(this.stations[aIndex].serviceArea.dots, markerIndex, [event.target._latlng.lat, event.target._latlng.lng])
            },
            waterNewPos(e, index) {
                this.$http.post('stations/water-update-cords?id=' + this.waterSources[index].id,
                        {
                            latLng: [e.target._latlng.lat, e.target._latlng.lng]
                        }).then(() => {
                    this.waterSources[index].latitude = e.target._latlng.lat
                    this.waterSources[index].longitude = e.target._latlng.lng
                }).catch(err => {
                    alert('Ошибка')
                    console.log(err)
                })

            },
            objectNewPos(e, marker, index) {
                this.$http.post('stations/object-update-cords?id=' + marker.areaObjects[index].id,
                        {
                            latLng: [e.target._latlng.lat, e.target._latlng.lng]
                        }).then(() => {

                }).catch(err => {
                    alert('Ошибка')
                    console.log(err)
                })
            },
            getIcon(url) {
                return icon({
                    iconUrl: url,
                    iconSize: [80, 80],
                    iconAnchor: [10, 80]
                })
            },
            getCords(cords) {
                if (cords) {
                    return latLng(cords[0], cords[1])
                }
                return latLng(0, 0)
            },
            getColor(level) {
                return color[level + 3].hexString

            },
            fetchData() {
                this.$http.get('stations/get-stations-cords',
                        {
                            params: {
                                id: 4
                            }
                        }).then(response => {
                    this.stations = response.data.stations
                    this.events = response.data.events
                })

            },
            getWater() {
                this.$http.get('area/water?lat1=' + this.$refs.mapBase.mapObject.getBounds()._northEast.lat +
                        '&lng1=' + this.$refs.mapBase.mapObject.getBounds()._northEast.lng +
                        '&lat2=' + this.$refs.mapBase.mapObject.getBounds()._southWest.lat +
                        '&lng2=' + this.$refs.mapBase.mapObject.getBounds()._southWest.lng +
                        '&zoom=' + this.$refs.mapBase.mapObject.getZoom()).then(response => {
                    this.waterSources = response.data
                })

            },
            animateTrack(index, newLat, newLng) {

                this.tracks[index].animate = true
                var seconds = 3
                var steps = 5
                const prevLat = this.tracks[index].lat
                const prevLng = this.tracks[index].lng
                for (var i = 1; i <= steps; i++) {
                    setTimeout(() => {

                        this.$set(this.tracks[index], 'lat', Number(this.tracks[index].lat) + Number((newLat - prevLat) / steps))
                        this.$set(this.tracks[index], 'lng', Number(this.tracks[index].lng) + Number((newLng - prevLng) / steps))
                    }, steps / seconds * i);
                }
            },
            getTracks() {
                this.$http.get('area/get-tracks').then(response => {
                    if (this.tracks.length == 0) {
                        this.tracks = response.data

                        for (var i in this.tracks) {
                            this.tracks[i].tempLat = this.tracks[i].lat
                            this.tracks[i].tempLng = this.tracks[i].lng
                        }
                    } else {
                        //Обновляем данные
                        for (var track of response.data) {
                            var index = this.tracks.findIndex(el => el.id == track.id)
                            if (index !== -1) {
                                if (this.tracks[index].tempLat != track.lat || this.tracks[index].tempLng != track.lng) {
                                    if (typeof track.lat !== 'undefined' && typeof track.lng !== 'undefined') {
                                        this.tracks[index].tempLat = track.lat
                                        this.tracks[index].tempLng = track.lng
                                        console.log(this.tracks[index])
                                        this.animateTrack(index, track.lat, track.lng)
                                    }

                                }
                                if (this.tracks[index].state != track.state) {
                                    this.tracks[index].state = track.state
                                    this.$set(this.tracks[index], 'showState', true)
                                    let that = this
                                    setTimeout(() => {
                                        this.$set(that.tracks[index], 'showState', false)
                                    }, 5000);
                                }
                            } else {
                                track.tempLat = track.lat
                                track.tempLng = track.lng
                                this.tracks.push(track)
                            }
                        }
                        //Удалем несуществующие записи
                        for (var key in this.tracks) {
                            if (response.data.findIndex(el => el.id == this.tracks[key].id) === -1) {
                                this.tracks.splice(key, 1)
                            }
                        }
                    }

                })

            },
            zoomUpdate(zoom) {
                this.getWater()
                this.currentZoom = zoom;
            },
            centerUpdate(center) {
                this.currentCenter = center;
            },
            innerClick() {
                alert("Click!");
            },
            stopTimer() {
                clearTimeout(this.timer)
            },
        },
        mounted() {
            window.addEventListener('resize', this.onResize, {passive: true})
            this.$nextTick(function () {
                this.$refs.mapBase.mapObject.invalidateSize(true)
                this.$refs.mapBase.mapObject.on("geosearch/showlocation",
                        this.search
                        );
            })
            this.timer = setInterval(() => {
                this.getTracks()
            }, 5000)
            this.fetchData()
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize, {passive: true})
            this.stopTimer()
        },
    }
</script>
